export { ConfirmationModal } from './ConfirmationModal';
export type { ConfirmationModalProps, ConfirmationModalVariant } from './ConfirmationModal.types';
